// // export default FarmerTable;
// import React, { useContext, useMemo, useState } from "react";
// import { motion, useReducedMotion } from "framer-motion";
// import FarmerOverlay from "../Components/FarmerOverlay";
// import DataContext from "../Context/DAtaContext";

// const PAGE_SIZE = 10;

// const FarmerTable = ({ users = [] }) => {
//   const { vegetableBundle, Payment, farmerbundle } = useContext(DataContext);

//   const [searchTerm, setSearchTerm] = useState("");
//   const [farmerId, setFarmerId] = useState("");
//   const [open, setOpen] = useState(false);
//   const [page, setPage] = useState(1);

//   const reduceMotion = useReducedMotion();

//   /*
//    * ---------------------------------------
//    * CREATE LOOKUP MAPS
//    * ---------------------------------------
//    */

//   // Vegetable bundles indexed by bundle id
//   const vegetableById = useMemo(() => {
//     const map = new Map();

//     (vegetableBundle ?? []).forEach((bundle) => {
//       if (bundle?.id !== undefined && bundle?.id !== null) {
//         map.set(bundle.id, bundle);
//       }
//     });

//     return map;
//   }, [vegetableBundle]);

//   // Farmer bundles indexed by farmer UUID
//   const bundlesByFarmer = useMemo(() => {
//     const map = new Map();

//     (farmerbundle ?? []).forEach((bundle) => {
//       const farmerKey = bundle?.farmer_id;

//       if (!farmerKey) return;

//       if (!map.has(farmerKey)) {
//         map.set(farmerKey, []);
//       }

//       map.get(farmerKey).push(bundle);
//     });

//     return map;
//   }, [farmerbundle]);

//   // Total payment indexed by farmer UUID
//   const paymentsByFarmer = useMemo(() => {
//     const map = new Map();

//     (Payment ?? []).forEach((payment) => {
//       const farmerKey = payment?.farmer_id;

//       if (!farmerKey) return;

//       const amount = Number(payment?.amount) || 0;

//       map.set(farmerKey, (map.get(farmerKey) || 0) + amount);
//     });

//     return map;
//   }, [Payment]);

//   /*
//    * ---------------------------------------
//    * SEARCH
//    * ---------------------------------------
//    */

//   const filteredUsers = useMemo(() => {
//     const search = searchTerm.trim().toLowerCase();

//     if (!search) return users;

//     return users.filter((user) => {
//       const name = (user?.name ?? "").toLowerCase();
//       const id = String(user?.id ?? "").toLowerCase();

//       return name.includes(search) || id.includes(search);
//     });
//   }, [users, searchTerm]);

//   /*
//    * ---------------------------------------
//    * PAGINATION
//    * ---------------------------------------
//    */

//   const totalPages = Math.max(1, Math.ceil(filteredUsers.length / PAGE_SIZE));

//   const currentPage = Math.min(page, totalPages);

//   const startIndex = (currentPage - 1) * PAGE_SIZE;

//   const displayedUsers = filteredUsers.slice(
//     startIndex,
//     startIndex + PAGE_SIZE,
//   );

//   /*
//    * ---------------------------------------
//    * FARMER SELECTION
//    * ---------------------------------------
//    */

//   const handleFarmer = (id) => {
//     setFarmerId(id);
//     setOpen(true);
//   };

//   const handleKeyboardOpen = (event, id) => {
//     if (event.key === "Enter" || event.key === " ") {
//       event.preventDefault();
//       handleFarmer(id);
//     }
//   };

//   /*
//    * ---------------------------------------
//    * SEARCH HANDLER
//    * ---------------------------------------
//    */

//   const handleSearch = (event) => {
//     setSearchTerm(event.target.value);
//     setPage(1);
//   };

//   return (
//     <div>
//       {/* Search */}
//       <div className="mb-4">
//         <div className="relative">
//           <label htmlFor="farmer-search" className="sr-only">
//             Search farmers
//           </label>

//           <input
//             id="farmer-search"
//             type="search"
//             placeholder="Search farmers..."
//             value={searchTerm}
//             onChange={handleSearch}
//             className="w-full py-2 pl-10 pr-4 rounded-lg outline-none sm:w-64 ring-inset focus:ring-2 focus:ring-green-600 dark:bg-gray-700 dark:text-gray-200 dark:ring-gray-700"
//           />

//           <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
//             <svg
//               className="w-5 h-5 text-gray-400"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//               aria-hidden="true"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
//               />
//             </svg>
//           </div>
//         </div>
//       </div>

//       {/* Farmer overlay */}
//       <FarmerOverlay FarmerId={farmerId} open={open} setOpen={setOpen} />

//       {/* Table container */}
//       <div className="relative overflow-y-auto max-h-96">
//         <table className="w-full">
//           <caption className="sr-only">Farmer payment information</caption>

//           <thead className="sticky top-0 z-20 text-white bg-green-600 shadow">
//             <tr>
//               <th
//                 scope="col"
//                 className="hidden p-2 text-xs text-left md:table-cell md:text-sm"
//               >
//                 No
//               </th>

//               <th scope="col" className="p-2 text-xs text-left md:text-sm">
//                 ID
//               </th>

//               <th scope="col" className="p-2 text-xs text-left md:text-sm">
//                 Name
//               </th>

//               <th
//                 scope="col"
//                 className="hidden p-2 text-xs text-left md:table-cell md:text-sm"
//               >
//                 Package
//               </th>

//               <th scope="col" className="p-2 text-xs text-center md:text-sm">
//                 Amount Paid
//               </th>

//               <th scope="col" className="p-2 text-xs text-center md:text-sm">
//                 %
//               </th>
//             </tr>
//           </thead>

//           <motion.tbody
//             initial={reduceMotion ? false : { opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{
//               duration: reduceMotion ? 0 : 0.3,
//             }}
//           >
//             {displayedUsers.length > 0 ? (
//               displayedUsers.map((user, index) => {
//                 /*
//                  * Get data using farmer UUID rather than
//                  * depending on array indexes.
//                  */
//                 const farmerKey = user?.uuid;

//                 const farmerBundles = bundlesByFarmer.get(farmerKey) ?? [];

//                 /*
//                  * Calculate total package value.
//                  *
//                  * Each farmer bundle looks up its own
//                  * vegetable bundle using bundle_id.
//                  */
//                 const totalAmount = farmerBundles.reduce(
//                   (total, farmerBundle) => {
//                     const bundle = vegetableById.get(farmerBundle?.bundle_id);

//                     const amount = Number(farmerBundle?.amount) || 0;

//                     const price = Number(bundle?.price) || 0;

//                     return total + amount * price;
//                   },
//                   0,
//                 );

//                 /*
//                  * Payment belonging specifically
//                  * to this farmer.
//                  */
//                 const amountPaid = paymentsByFarmer.get(farmerKey) ?? 0;

//                 /*
//                  * Payment percentage
//                  */
//                 const percentage =
//                   totalAmount > 0 ? (amountPaid / totalAmount) * 100 : 0;

//                 /*
//                  * Existing percentage colors retained
//                  */
//                 let percentageColor = "text-green-500";

//                 if (percentage < 33) {
//                   percentageColor = "text-red-500";
//                 } else if (percentage < 66) {
//                   percentageColor = "text-yellow-500";
//                 }

//                 return (
//                   <motion.tr
//                     key={user?.uuid ?? user?.id}
//                     initial={
//                       reduceMotion
//                         ? false
//                         : {
//                             opacity: 0,
//                             y: 12,
//                           }
//                     }
//                     animate={{
//                       opacity: 1,
//                       y: 0,
//                     }}
//                     transition={{
//                       delay: reduceMotion ? 0 : index * 0.04,
//                     }}
//                     onClick={() => handleFarmer(user?.id)}
//                     onKeyDown={(event) => handleKeyboardOpen(event, user?.id)}
//                     tabIndex={0}
//                     aria-label={`Open ${user?.name ?? "farmer"} details`}
//                     className="transition duration-150 ease-in-out bg-white border-b cursor-pointer dark:border-b-gray-700 dark:hover:bg-gray-700 dark:text-gray-300 dark:bg-slate-900 hover:bg-green-300 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-inset"
//                   >
//                     <td className="hidden p-2 text-xs md:table-cell md:py-3 md:text-sm">
//                       {startIndex + index + 1}
//                     </td>

//                     <td className="p-2 text-xs md:py-3 md:text-sm">
//                       {user?.id}
//                     </td>

//                     <td className="p-2 text-xs md:py-3 md:text-sm">
//                       {user?.name}

//                       {/* Show package on mobile */}
//                       <div className="text-xs text-gray-500 md:hidden">
//                         {user?.prefered_bundle}
//                       </div>
//                     </td>

//                     <td className="hidden p-2 text-xs md:py-3 md:table-cell md:text-sm">
//                       {user?.prefered_bundle}
//                     </td>

//                     <td className="p-2 text-xs text-center md:p-3 md:text-sm">
//                       {amountPaid.toLocaleString()}
//                     </td>

//                     <td className="p-2 text-xs text-center md:p-3 md:text-sm">
//                       <span className={percentageColor}>
//                         {percentage.toFixed(2)}%
//                       </span>
//                     </td>
//                   </motion.tr>
//                 );
//               })
//             ) : (
//               <tr>
//                 <td
//                   colSpan={6}
//                   className="p-4 text-xs text-center text-gray-500 md:text-sm"
//                 >
//                   {searchTerm
//                     ? "No farmers match your search."
//                     : "No farmers available."}
//                 </td>
//               </tr>
//             )}
//           </motion.tbody>
//         </table>
//       </div>

//       {/* Footer / Pagination */}
//       {filteredUsers.length > 0 && (
//         <div className="flex items-center justify-between mt-3">
//           <p className="text-xs text-gray-500 dark:text-gray-500">
//             Showing {startIndex + 1}–
//             {Math.min(startIndex + PAGE_SIZE, filteredUsers.length)} of{" "}
//             {filteredUsers.length} farmers
//           </p>

//           {totalPages > 1 && (
//             <div className="flex items-center gap-2">
//               <button
//                 type="button"
//                 onClick={() => setPage((current) => Math.max(current - 1, 1))}
//                 disabled={currentPage === 1}
//                 className="px-3 py-1 text-xs text-white bg-green-600 rounded disabled:opacity-50"
//                 aria-label="Previous page"
//               >
//                 Previous
//               </button>

//               <span className="text-xs text-gray-500">
//                 {currentPage} / {totalPages}
//               </span>

//               <button
//                 type="button"
//                 onClick={() =>
//                   setPage((current) => Math.min(current + 1, totalPages))
//                 }
//                 disabled={currentPage === totalPages}
//                 className="px-3 py-1 text-xs text-white bg-green-600 rounded disabled:opacity-50"
//                 aria-label="Next page"
//               >
//                 Next
//               </button>
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default FarmerTable;
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import FarmerOverlay from "../Components/FarmerOverlay";
import DataContext from "../Context/DAtaContext";

const PAGE_SIZE = 10;

const FarmerTable = ({ users = [] }) => {
  const { vegetableBundle, Payment, farmerbundle } = useContext(DataContext);

  const [searchTerm, setSearchTerm] = useState("");
  const [farmerId, setFarmerId] = useState("");
  const [open, setOpen] = useState(false);

  // Number of pages currently loaded
  const [page, setPage] = useState(1);

  const scrollContainerRef = useRef(null);
  const loadMoreRef = useRef(null);

  const reduceMotion = useReducedMotion();

  /*
   * ---------------------------------------
   * CREATE LOOKUP MAPS
   * ---------------------------------------
   */

  // Vegetable bundles indexed by bundle id
  const vegetableById = useMemo(() => {
    const map = new Map();

    (vegetableBundle ?? []).forEach((bundle) => {
      if (bundle?.id !== undefined && bundle?.id !== null) {
        map.set(bundle.id, bundle);
      }
    });

    return map;
  }, [vegetableBundle]);

  // Farmer bundles indexed by farmer UUID
  const bundlesByFarmer = useMemo(() => {
    const map = new Map();

    (farmerbundle ?? []).forEach((bundle) => {
      const farmerKey = bundle?.farmer_id;

      if (!farmerKey) return;

      if (!map.has(farmerKey)) {
        map.set(farmerKey, []);
      }

      map.get(farmerKey).push(bundle);
    });

    return map;
  }, [farmerbundle]);

  // Total payment indexed by farmer UUID
  const paymentsByFarmer = useMemo(() => {
    const map = new Map();

    (Payment ?? []).forEach((payment) => {
      const farmerKey = payment?.farmer_id;

      if (!farmerKey) return;

      const amount = Number(payment?.amount) || 0;

      map.set(farmerKey, (map.get(farmerKey) || 0) + amount);
    });

    return map;
  }, [Payment]);

  /*
   * ---------------------------------------
   * SEARCH
   * ---------------------------------------
   */

  const filteredUsers = useMemo(() => {
    const search = searchTerm.trim().toLowerCase();

    if (!search) return users;

    return users.filter((user) => {
      const name = (user?.name ?? "").toLowerCase();
      const id = String(user?.id ?? "").toLowerCase();

      return name.includes(search) || id.includes(search);
    });
  }, [users, searchTerm]);

  /*
   * ---------------------------------------
   * INFINITE SCROLL PAGINATION
   * ---------------------------------------
   */

  const totalPages = Math.max(1, Math.ceil(filteredUsers.length / PAGE_SIZE));

  const currentPage = Math.min(page, totalPages);

  // Instead of showing only one page,
  // keep all previously loaded pages visible.
  const displayedUsers = filteredUsers.slice(0, currentPage * PAGE_SIZE);

  const hasMore = displayedUsers.length < filteredUsers.length;

  /*
   * Observe the bottom of the table.
   * When it becomes visible, automatically
   * load the next page.
   */
  useEffect(() => {
    const target = loadMoreRef.current;
    const scrollContainer = scrollContainerRef.current;

    if (!target || !scrollContainer || !hasMore) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (entry.isIntersecting) {
          setPage((current) => Math.min(current + 1, totalPages));
        }
      },
      {
        root: scrollContainer,

        // Start loading slightly before the
        // user reaches the absolute bottom.
        rootMargin: "120px 0px",

        threshold: 0,
      },
    );

    observer.observe(target);

    return () => {
      observer.disconnect();
    };
  }, [hasMore, totalPages]);

  /*
   * ---------------------------------------
   * FARMER SELECTION
   * ---------------------------------------
   */

  const handleFarmer = (id) => {
    setFarmerId(id);
    setOpen(true);
  };

  const handleKeyboardOpen = (event, id) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleFarmer(id);
    }
  };

  /*
   * ---------------------------------------
   * SEARCH HANDLER
   * ---------------------------------------
   */

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);

    // Start infinite scroll from the first
    // page whenever the search changes.
    setPage(1);

    // Return the table to the top.
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
  };

  return (
    <div>
      {/* Search */}
      <div className="mb-4">
        <div className="relative">
          <label htmlFor="farmer-search" className="sr-only">
            Search farmers
          </label>

          <input
            id="farmer-search"
            type="search"
            placeholder="Search farmers..."
            value={searchTerm}
            onChange={handleSearch}
            className="w-full py-2 pl-10 pr-4 rounded-lg outline-none sm:w-64 ring-inset focus:ring-2 focus:ring-green-600 dark:bg-gray-700 dark:text-gray-200 dark:ring-gray-700"
          />

          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <svg
              className="w-5 h-5 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* Farmer overlay */}
      <FarmerOverlay FarmerId={farmerId} open={open} setOpen={setOpen} />

      {/* Table container */}
      <div
        ref={scrollContainerRef}
        className="relative overflow-y-auto max-h-96"
      >
        <table className="w-full">
          <caption className="sr-only">Farmer payment information</caption>

          <thead className="sticky top-0 z-20 text-white bg-green-600 shadow">
            <tr>
              <th
                scope="col"
                className="hidden p-2 text-xs text-left md:table-cell md:text-sm"
              >
                No
              </th>

              <th scope="col" className="p-2 text-xs text-left md:text-sm">
                ID
              </th>

              <th scope="col" className="p-2 text-xs text-left md:text-sm">
                Name
              </th>

              <th
                scope="col"
                className="hidden p-2 text-xs text-left md:table-cell md:text-sm"
              >
                Package
              </th>

              <th scope="col" className="p-2 text-xs text-center md:text-sm">
                Amount Paid
              </th>

              <th scope="col" className="p-2 text-xs text-center md:text-sm">
                %
              </th>
            </tr>
          </thead>

          <motion.tbody
            initial={reduceMotion ? false : { opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              duration: reduceMotion ? 0 : 0.3,
            }}
          >
            {displayedUsers.length > 0 ? (
              displayedUsers.map((user, index) => {
                const farmerKey = user?.uuid;

                const farmerBundles = bundlesByFarmer.get(farmerKey) ?? [];

                const totalAmount = farmerBundles.reduce(
                  (total, farmerBundle) => {
                    const bundle = vegetableById.get(farmerBundle?.bundle_id);

                    const amount = Number(farmerBundle?.amount) || 0;

                    const price = Number(bundle?.price) || 0;

                    return total + amount * price;
                  },
                  0,
                );

                const amountPaid = paymentsByFarmer.get(farmerKey) ?? 0;

                const percentage =
                  totalAmount > 0 ? (amountPaid / totalAmount) * 100 : 0;

                let percentageColor = "text-green-500";

                if (percentage < 33) {
                  percentageColor = "text-red-500";
                } else if (percentage < 66) {
                  percentageColor = "text-yellow-500";
                }

                return (
                  <motion.tr
                    key={user?.uuid ?? user?.id}
                    initial={
                      reduceMotion
                        ? false
                        : {
                            opacity: 0,
                            y: 12,
                          }
                    }
                    animate={{
                      opacity: 1,
                      y: 0,
                    }}
                    transition={{
                      delay: reduceMotion ? 0 : (index % PAGE_SIZE) * 0.04,
                    }}
                    onClick={() => handleFarmer(user?.id)}
                    onKeyDown={(event) => handleKeyboardOpen(event, user?.id)}
                    tabIndex={0}
                    aria-label={`Open ${user?.name ?? "farmer"} details`}
                    className="transition duration-150 ease-in-out bg-white border-b cursor-pointer dark:border-b-gray-700 dark:hover:bg-gray-700 dark:text-gray-300 dark:bg-slate-900 hover:bg-green-300 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-inset"
                  >
                    <td className="hidden p-2 text-xs md:table-cell md:py-3 md:text-sm">
                      {index + 1}
                    </td>

                    <td className="p-2 text-xs md:py-3 md:text-sm">
                      {user?.id}
                    </td>

                    <td className="p-2 text-xs md:py-3 md:text-sm">
                      {user?.name}

                      {/* Show package on mobile */}
                      <div className="text-xs text-gray-500 md:hidden">
                        {user?.prefered_bundle}
                      </div>
                    </td>

                    <td className="hidden p-2 text-xs md:py-3 md:table-cell md:text-sm">
                      {user?.prefered_bundle}
                    </td>

                    <td className="p-2 text-xs text-center md:p-3 md:text-sm">
                      {amountPaid.toLocaleString()}
                    </td>

                    <td className="p-2 text-xs text-center md:p-3 md:text-sm">
                      <span className={percentageColor}>
                        {percentage.toFixed(2)}%
                      </span>
                    </td>
                  </motion.tr>
                );
              })
            ) : (
              <tr>
                <td
                  colSpan={6}
                  className="p-4 text-xs text-center text-gray-500 md:text-sm"
                >
                  {searchTerm
                    ? "No farmers match your search."
                    : "No farmers available."}
                </td>
              </tr>
            )}
          </motion.tbody>
        </table>

        {/* Infinite scroll trigger */}
        {hasMore && (
          <div
            ref={loadMoreRef}
            className="flex items-center justify-center h-12"
            aria-hidden="true"
          >
            <div className="w-5 h-5 border-2 border-gray-300 rounded-full border-t-green-600 animate-spin" />
          </div>
        )}
      </div>

      {/* Record count only — pagination buttons removed */}
      {filteredUsers.length > 0 && (
        <div className="mt-3">
          <p className="text-xs text-gray-500 dark:text-gray-500">
            Showing {displayedUsers.length} of {filteredUsers.length} farmers
          </p>
        </div>
      )}
    </div>
  );
};

export default FarmerTable;
